// pharmacies.js

const pharmacies = [
    "Ashbourne Pharmacy", "Ascent Nabbs Lane", "Ascent Russell Drive", "Ascent Sherwood Pharmacy",
    "Barming Pharmacy", "Barlow Pharmacy", "Battlehill Pharmacy", "Berwick Pharmacy", "Blaby Pharmacy",
    "Bloomfield Pharmacy", "Boxalls Pharmacy", "Bovey Tracey Pharmacy", "Brannam Pharmacy", "Brockwell Pharmacy",
    "Buxton Pharmacy", "Chain Lane Pharmacy", "Chapel Street Pharmacy", "Clive Parade Pharmacy", "Clowne Pharmacy",
    "Coulby Newham Pharmacy", "Crich Pharmacy", "Delamere Pharmacy", "Dudley Pharmacy", "Duffield Pharmacy",
    "Fountain Street Pharmacy", "Gorton Pharmacy", "Gove Green Pharmacy", "Haslands Pharmacy", "Healey Pharmacy",
    "Holme Hall Pharmacy", "Hollington Pharmacy", "Junction Pharmacy", "Legh Street Pharmacy", "Longhill Pharmacy",
    "Middle Warren Pharmacy", "Middleton Pharmacy", "MiddletonPharmacy", "Moorlands Pharmacy", "Mount Road Pharmacy",
    "Porterbrook Pharmacy", "Portway Pharmacy", "Rainhill Pharmacy", "Skipton Pharmacy", "Springfield Pharm",
    "Stock - Excess", "Stock - Expiring", "Stock - Financials", "Stock - Slow Movers", "Stock - Warehouse",
    "Torkard Hill Pharmacy", "Tweedmouth Pharmacy", "Villers Pharmacy", "Wellfield Pharmacy", "West Street Pharmacy",
    "Whitwick Road Pharmacy", "Winterbottom Pharmacy"
  ];
  
  const groupId = "674018cd9b64e7c386beeae4";
  
  export { groupId };  // Named export for groupId
  export default pharmacies;  // Default export for pharmacies
  